const PLATFORM: string = 'panama';
const COUNTRY: string = 'PA';
const LANGUAGE: string = 'es';
const TIMEZONE: string = 'America/Panama';
const PHONE_PREFIX: string = '+507';
const PHONE_PREFIX_BBDD: string = '507';
const MINIMAL_CHAR_LENGTH: number = 10;
const MINIMAL_AGE: number = 18;

const getPlatform = (): string => PLATFORM;
const getCountry = (): string => COUNTRY;
const getLanguage = (): string => LANGUAGE;
const getTimezone = (): string => TIMEZONE;
const getMinimalCharLength = (): number => MINIMAL_CHAR_LENGTH;

const getBaseUrl = (): string => {
  return `${window.location.protocol}//${window.location.hostname}`;
};

export {
  getMinimalCharLength,
  getPlatform,
  getCountry,
  getLanguage,
  getTimezone,
  getBaseUrl,
  MINIMAL_AGE,
  PHONE_PREFIX,
  PHONE_PREFIX_BBDD,
};
